import * as React from 'react';
import translate from '../../../../locale/translate';

import { renderEmpty } from '../../common/Render';
import SimplePieChart from '../../common/Chart/SimplePieChart';
import { getDisplayValue, formatDate } from '../../util/StringUtil';

import { IReportSettings, SU } from '../../../../interfaces';

import ISettings from './ISettings';
import IWidgetProps from './IWidgetProps';


interface IProps extends IWidgetProps {
    settings: ISettings;
}

const AVAILABLE_COLS = [
    'name',
    'categoryState',
    'LastJobTime',
];

const COL_TITLES = {
    name: translate.gettext("Name"),
    categoryState: translate.gettext("State"),
    LastJobTime: translate.gettext("Last job date"),
};

const HEADER_CLASSES = {
    name: '',
    categoryState: 'col-xs-2',
    LastJobTime: 'col-xs-2',
};

const COL_CLASSES = {
    name: '',
    categoryState: '',
    LastJobTime: '',
};

const agents = {};

export default class Widget extends React.Component<IProps, {}> {
    static propTypes = {
        systems: React.PropTypes.array.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    getRowCls(system: SU.ISystem) {
        if (!system.suInformation.enabled) {
            return 'warning';
        }

        return '';
    }

    renderColumnHead(name: string, settings: ISettings) {
        if (getDisplayValue(name, settings)) {
            return (
                <th key={name} className={HEADER_CLASSES[name]}>{COL_TITLES[name]}</th>
            );
        }

        return;
    }

    renderColumn(name: string, system: SU.ISystem, settings: ISettings) {
        if (getDisplayValue(name, settings)) {
            let value = system[name];

            if (!value && system.suInformation && system.suInformation.enabled) {
                value = system.suInformation[name];
            } else if (!value && !system.suInformation.enabled) {
                value = translate.gettext('No SU installed');
            }

            if (name === 'LastJobTime' && system.suInformation.enabled && system.suInformation.lastJob) {
                value = formatDate(system.suInformation.lastJob.createdOn, 'L LT');
            }

            if (name === "categoryState" && system.suInformation.enabled) {
                if (system.agent && system.agent.state) {
                    value = translate.gettext('There were problems with the update');
                } else {
                    switch(system.suInformation.categoryState) {
                        case 'ERROR': {
                            value = translate.gettext('There were problems with the update');
                            break;
                        }
                        case 'OK': {
                            value = translate.gettext('OK');
                            break;
                        }
                        case 'IN_PROGRESS': {
                            value = translate.gettext('In progress');
                            break;
                        }
                    }
                }
            }

            return (
                <td key={name} className={COL_CLASSES[name]}>{value}</td>
            );
        }

        return;
    }

    renderSystem(system: SU.ISystem, settings: ISettings) {
        return (
            <tr key={system.id} className={this.getRowCls(system)}>
                {AVAILABLE_COLS.map(name => {
                    return this.renderColumn(name, system, settings);
                })}
            </tr>
        );
    }

    getChartData(systems: SU.ISystem[]) {
        return systems.reduce((systemCount, system: SU.ISystem) => {
            if (system.suInformation.enabled) {
                systemCount.has++;
            } else {
                systemCount.hasNo++;
            }

            return systemCount;
        }, {
                has: 0,
                hasNo: 0,
            });
    }

    renderChart({ has, hasNo }) {
        const data = [
            { x: translate.gettext('Without SU'), y: hasNo },
            { x: translate.gettext('With SU'), y: has },
        ];

        return (
            <div key="chart" className="text-center">
                <SimplePieChart data={data} />
            </div>
        );
    }

    renderData(systems: SU.ISystem[], settings: ISettings, reportSettings: IReportSettings) {
        const headers = AVAILABLE_COLS.map(name => {
            return this.renderColumnHead(name, settings);
        }).filter(header => !!header);

        const rows = systems.map((system, idx) => {
            return this.renderSystem(system, settings);
        });

        const children = [];

        if (settings.displayChart) {
            children.push(this.renderChart(this.getChartData(this.props.systems)));
        }

        if (settings.displayTable) {
            children.push(
                <table className="table" key="table">
                    <thead>
                        <tr>
                            {headers}
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            );
        }

        return (
            <div>
                {children}
            </div>
        );
    }

    render() {
        let { systems } = this.props;
        const { settings, reportSettings } = this.props;

        systems = systems.filter(system => {
            if (!system.suInformation.enabled && !settings.displaySystemsWithoutSu) {
                return false;
            }

            return true;
        });

        let renderedData;
        if (systems && systems.length) {
            renderedData = this.renderData(systems, settings, reportSettings);
        } else {
            renderedData = renderEmpty();
        }

        return (
            <div>
                {renderedData}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/su/listSystems/Widget.tsx